<!-- src/components/GlassItem.vue -->
<template>
    <div class="col-md-4 glass-item" v-if="!loading">
        <b-overlay
            :show="!photoDatas || loadedImages < photoDatas.length"
            spinner-variant="primary"
            spinner-type="grow"
            :opacity="1"
            spinner-small
            rounded="sm"
            style="height:90%"
            >
            <div class="grey-image" @click="$router.push({name:'editGlass', params: { id: glass.id }})">
                <div class="img">
                    <template v-if="glass.id==64"><img src="https://visages.com/assets/images/sasha/01_G_black.png" /></template>
                    <template v-else>
                        <img v-for="(layer, index_layer) in photoDatas" @load="imageLoaded" :key="index_layer" :src="calculatePhoto(layer)" :class="{'render-layer2':index_layer>0}"  :style="'opacity:'+getOpacityElement(index_layer)+';'" />
                    </template>
                </div>
            </div>
        </b-overlay>
        <div class="bottom-product">
            <div class="title-glass">{{glass.name}}</div>
            <div class="right-bottom">
                <div class="price-glass">{{glass.price+20}}€</div>
                <div v-if="language=='fr'" class="button-glass" @click="$router.push({name:'editGlass', params: { id: glass.id }})">Voir</div>
                <div v-else class="button-glass" @click="$router.push({name:'editGlass', params: { id: glass.id }})">See</div>
            </div>
        </div>
    </div>
    <div class="col-md-4 " v-else>
        LOADING...
        
    </div>
    
</template>

<script>
import {APIRequest} from '@simb2s/senseye-sdk'
import {BModal, BTable, BTableSimple, BTableLite, BTd, BTbody, BTr, BTh, BThead, BPagination, BRow, BButton, VBModal,BOverlay, BCard, BCardText, BAvatar, BBadge, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import { languages } from 'prismjs'

export default {
    props: ['glass','language'],
    components: {
        BOverlay,

    },
    data() {
        return {
            photoDatas:[1,2,3],
            loading:true,
            loadedImages: 0,
        }
    },
    methods:{
        imageLoaded() {
            this.loadedImages++
        },
        calculatePhoto(layer_info) {
            let hue = layer_info.presets.hue_app ? layer_info.presets.hue_app : 100
            let saturation = layer_info.presets.saturation ? layer_info.presets.saturation : 100
            let brightness = layer_info.presets.brightness ? layer_info.presets.brightness : 100


            let url
            if(brightness==100 && hue==100 && saturation==100)
            {
                if(this.glass.id!=25 && this.glass.id!=26 && this.glass.id!=27 && this.glass.id!=28)
                {
                    url = 'https://api.sens-eye.fr/render_parts_new/'+layer_info.render
                }
                else
                {
                    url = 'https://api.sens-eye.fr/render_parts/'+layer_info.render
                }
            }
            else {
                if(this.glass.id!=25 && this.glass.id!=26 && this.glass.id!=27 && this.glass.id!=28)
                {
                    url = 'https://api.sens-eye.fr/api/photo-single-test2?photo='+layer_info.render+'&hue='+hue+'&saturation='+saturation+'&brightness='+brightness
                }
                else
                {
                    url = 'https://api.sens-eye.fr/api/photo-single-test?photo='+layer_info.render+'&hue='+hue+'&saturation='+saturation+'&brightness='+brightness
                }
            }

            //this.$emit('calculatePhotoEv',0)

            return url
        },
        getOpacityElement(layer) {
          if(this.photoDatas[layer].presets.opacity != null) {
                return this.photoDatas[layer].presets.opacity/100
            }
            else {
                return 1
            }
        },
        async calculatePhotos(){
            let request = '?glass='+this.glass.id+'&branch=4'
            let model_parts_data=this.glass.model_parts

            // List endpoint may omit nested model_parts for some glasses
            if(!model_parts_data || !model_parts_data.length) {
                try {
                    const glassDetail = await APIRequest.detail('glasses', this.glass.id)
                    model_parts_data = glassDetail && glassDetail.model_parts
                    if(glassDetail) {
                        if(glassDetail.default_color != null) this.glass.default_color = glassDetail.default_color
                        if(glassDetail.default_tint != null) this.glass.default_tint = glassDetail.default_tint
                    }
                } catch (e) {
                    console.error('GlassItem: failed to load glass detail', e)
                }
            }

            if(!model_parts_data || !model_parts_data.length) {
                this.photoDatas = []
                return
            }
                
            for(let j=0;j<model_parts_data.length;j++) {
                if(model_parts_data[j].render_type!="shadow" && model_parts_data[j].render_type!="hinge" && model_parts_data[j].render_type!="manchon"){
                    if(model_parts_data[j].type=='color') {
                        if(model_parts_data[j].render_slug=="frame" || model_parts_data[j].render_slug=="frame1")
                        {
                            if(model_parts_data[j].material=="plastic")
                            {
                                if(this.glass.default_color!=null && model_parts_data[j].render_slug!="frame1")
                                {
                                    console.log('default color',this.glass.default_color)
                                    request+='&color_'+model_parts_data[j].render_slug+'='+this.glass.default_color.id
                                }
                                else
                                {
                                    if(this.glass.id==29)
                                    {
                                        request+='&color_'+model_parts_data[j].render_slug+'=6'
                                    }
                                    else
                                    {
                                        request+='&color_'+model_parts_data[j].render_slug+'=10'
                                    }
                                }
                            }
                            else 
                            {
                                if(this.glass.default_color!=null && model_parts_data[j].render_slug!="frame1")
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'='+this.glass.default_color.id
                                }
                                else
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'=19'
                                }
                            }
                            request+='&texture_style_'+model_parts_data[j].render_slug+'=0'
                        }
                        else if(model_parts_data[j].render_slug=="temples" || model_parts_data[j].render_slug=="temple1")
                        {
                            if(model_parts_data[j].material=="plastic")
                            {
                                if(this.glass.default_color!=null)
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'='+this.glass.default_color.id
                                }
                                else
                                {
                                    if(this.glass.id==29)
                                    {
                                        request+='&color_'+model_parts_data[j].render_slug+'=6'
                                    }
                                    else
                                    {
                                        if(model_parts_data[j].colors && model_parts_data[j].colors.length)
                                        {
                                            request+='&color_'+model_parts_data[j].render_slug+'='+model_parts_data[j].colors[0].id
                                        }
                                        else
                                        {
                                            request+='&color_'+model_parts_data[j].render_slug+'=10'
                                        }
                                    }
                                }

                            }
                            else {
                                if(model_parts_data[j].colors && model_parts_data[j].colors.length)
                                        {
                                            request+='&color_'+model_parts_data[j].render_slug+'='+model_parts_data[j].colors[0].id
                                        }
                                        else
                                        {
                                            request+='&color_'+model_parts_data[j].render_slug+'=20'
                                        }
                            }
                            request+='&texture_style_'+model_parts_data[j].render_slug+'=0'
                        }
                        else {
                        if(model_parts_data[j].material=="plastic")
                        {
                            request+='&color_'+model_parts_data[j].render_slug+'=10'
                           
                        }
                        else {
                            request+='&color_'+model_parts_data[j].render_slug+'=19'
                            
                        }
                        
                        }
                        request+='&texture_'+model_parts_data[j].render_slug+'=4'
                    
                    }
                    else if(model_parts_data[j].type=='texture_color') { 
                
                
                        if(model_parts_data[j].render_slug=="frame" || model_parts_data[j].render_slug=="frame1")
                        {

                            if(this.glass.default_color!=null && model_parts_data[j].render_slug!="frame1")
                            {
                                request+='&color_'+model_parts_data[j].render_slug+'='+this.glass.default_color.id
                            }
                            else
                            {

                                if(model_parts_data[j].material=="plastic")
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'=10'
                                }
                                else 
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'=19'
                                }
                            }
                            
                            request+='&texture_style_'+model_parts_data[j].render_slug+'=0'
                        }
                        else if(model_parts_data[j].render_slug=="temples" || model_parts_data[j].render_slug=="temple1")
                        {
                            if(model_parts_data[j].material=="plastic")
                            {
                                if(this.glass.default_color!=null)
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'='+this.glass.default_color.id
                                }
                                else
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'=10'
                                }
                            }
                            else {
                                if(model_parts_data[j].colors && model_parts_data[j].colors.length)
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'='+model_parts_data[j].colors[0].id
                                }
                                else
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'=20'
                                }
                            }
                        request+='&texture_style_'+model_parts_data[j].render_slug+'=0'
                        }
                        else {
                            if(model_parts_data[j].material=="plastic")
                            {
                                request+='&color_'+model_parts_data[j].render_slug+'=10'
                            }
                            else {
                                request+='&color_'+model_parts_data[j].render_slug+'=19'
                            }
                        
                        }
                        
                        request+='&texture_'+model_parts_data[j].render_slug+'=4'
                
                    }
                    else if (model_parts_data[j].render_type=="lense")
                    {
                        // ici tint
                        let default_tint=4
                        if(this.selectedFilter=='optic')
                        {
                            default_tint=5
                        }
                        else 
                        {
                            if(this.glass.default_tint!=null)
                            {
                                default_tint=this.glass.default_tint.id
                            }
                               
                        }
                      
                        request+='&tint_'+model_parts_data[j].render_slug+'='+default_tint
                        
                    }

                    }
                    else if (model_parts_data[j].render_type=="manchon")
                    {
                        request+='&color_'+model_parts_data[j].render_slug+'=24'
                   
                    }
                }
                let render_infos
                if(this.glass.id!=25 && this.glass.id!=26 && this.glass.id!=27 && this.glass.id!=28)
                {
                    render_infos =  await APIRequest.list_renders('photos-layers-new2',request)
                }
                else
                {
                    render_infos =  await APIRequest.list_renders('photos-layers-new',request)
                }
                
                let render_infos_datas=render_infos || {}
                
                if(this.glass.id==26)
                {
                 
                    this.photoDatas=render_infos_datas.scene1 || []
                }
                else {
                    
                    this.photoDatas=render_infos_datas.scene2 || []
                }
  }
    },
    async mounted() {
        try {
            await this.calculatePhotos()
        } catch (e) {
            console.error('GlassItem mounted error', e)
            this.photoDatas = []
        }
        this.loading=false
    }
}
</script>

<style scoped>
.glass-item {
  margin-bottom: 20px;
}
.grey-image img
{

  width:100%;
  height:auto;
}
.grey-image .img .render-layer2
{
  position:absolute;
  width:100%;
  left:0;
  top:0;
  height:auto;
}
.grey-image .img 
{
  position:relative;
}
.grey-image {
    cursor: pointer;
  background: #F7F7F7;
  border: 0.5px solid #999999;
  border-radius: 10px;
  padding-top:50px;
  padding-bottom:50px;
}
.bottom-product
{
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.right-bottom
{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-glass
{
  font-size: 20px;
  font-weight: 500;
}
.price-glass
{
  font-size: 20px;
  font-weight: 500;
}
.button-glass
{
    cursor: pointer;
  margin-left: 10px;
  background: #000;
  padding: 5px 30px;
  border-radius: 10px;
  font-size:13px;
  color: white;
  font-weight: 400;
}
@media screen and (min-width:1024px) and (max-width:1400px)
{
    .title-glass
{
  font-size: 14px;
  font-weight: 500;
}
.price-glass
{
  font-size: 14px;
  font-weight: 500;
}
}
</style>